import React from 'react';
import { Carousel, CarouselItem, SlickCarouselProvider, CarouselPrevious, CarouselNext } from './../../context/Slider';
import { NextPrevArrow } from '../../helper/Icons';

function Provider({ icon, sectionHeading, TabData, right = false, className, autoplay = false }) {
    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        autoplay: autoplay,
        speed: 500,
        slidesToShow: 8.05,
        slidesToScroll: 1,
        swipeToSlide: true,
        rtl: right,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 7.06,
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6.06,
                }
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 5.06,
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 4.06,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 3.07,
                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 2.06,
                }
            }
        ]
    };

    return (
        <>
            <div className='wrapper mx-auto'>
                <SlickCarouselProvider settings={settings} className={className}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                        <h2 className='text-white fs-22 fw-bold m-0'><span className='opacity-50 me-2'>{icon}</span>{sectionHeading}</h2>
                        <div className='d-flex align-items-center gap-2'>
                            <CarouselPrevious customButton={
                                <button className="btn bg-darkslate max-w-h-33 d-flex p-1"><NextPrevArrow /></button>
                            } />
                            <CarouselNext customButton={
                                <button className="btn bg-darkslate rotate-180 max-w-h-33 d-flex p-1"><NextPrevArrow /></button>
                            } />
                        </div>
                    </div>
                    <Carousel >
                        {TabData.map((data, index) => {
                            return (
                                <CarouselItem key={index} className='d-flex justify-content-center mx-2'>
                                    <div className='bg-haiti border-ebonyclay text-center rounded-3 w-100 max-w-144 max-h-72 d-flex justify-content-center align-items-center py-4'>
                                        {data.icon}
                                    </div>
                                </CarouselItem>
                            )
                        })}
                    </Carousel>
                </SlickCarouselProvider>
            </div>
        </>
    );
}

export default Provider;
